import { fetchCities } from "../../services/citiesService";
import { citiesFetched } from "../actions/citiesAction";
import { hideLoading } from "../../shared/widgets/bar-loader/src";
import { createAllActionCreators } from "./actionCreatorUtil";

const citiesActionCreators = {
  createCitiesListAction: {
    service: fetchCities,
    responseFn: (response, params) => {
      const { dispatch, loaderType } = params;
      // eslint-disable-next-line no-restricted-syntax
      for (const data of response) {
        data.uniqId = data.cityId?.toString();
      }
      const allCitiesIndex = response.findIndex(
        (city) => city.cityName === "All Cities",
      );
      if (response.length && allCitiesIndex > -1) {
        response.splice(allCitiesIndex, 1);
      }
      dispatch(citiesFetched(response));
      dispatch(hideLoading(loaderType));
    },
  },
};

export const { createCitiesListAction } = createAllActionCreators(citiesActionCreators);
